import {hasValidAsset} from './utils'

/**
 * Selects the media asset used for a Media Module at the current viewport.
 *
 * @param {Object} options - Media Module assets and viewport state
 * @param {Object} [options.asset] - Portrait asset
 * @param {Object} [options.assetLandscape] - Landscape asset
 * @param {'landscape'|'portrait'} [options.variant='landscape'] - Module variant
 * @param {boolean} [options.isDesktop=false] - Whether the viewport is at breakpoint s or wider
 * @returns {Object|null} The valid asset to render, or null when neither asset is valid
 */
export const getMediaAssetForViewport = ({
    asset,
    assetLandscape,
    variant = 'landscape',
    isDesktop = false
}) => {
    const primaryAsset = variant === 'portrait' && !isDesktop ? asset : assetLandscape
    const fallbackAsset = primaryAsset === asset ? assetLandscape : asset

    if (hasValidAsset(primaryAsset)) return primaryAsset
    if (hasValidAsset(fallbackAsset)) return fallbackAsset

    return null
}
